module.exports = __webpack_public_path__ + "neverGame3.png?1c9765b33b490e0d622947e0cdd8e71f";